import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconWarningFilled = ({ id, color, width = 49, style, ...restProps }: IProps) => {
  const viewBoxWidth = 49;
  const viewBoxHeight = 40;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        fillRule="evenodd"
        d="M47.039 40H1.96a1.96 1.96 0 0 1-1.717-1.02 1.987 1.987 0 0 1 .058-2.007L22.84.923A1.958 1.958 0 0 1 24.5 0c.673 0 1.3.349 1.659.923l22.539 36.05c.381.608.403 1.377.058 2.007A1.962 1.962 0 0 1 47.04 40zM24.79 27.926c1.096 0 1.983-.85 1.983-1.9V15.74c0-1.05-.887-1.9-1.983-1.9-1.095 0-1.983.85-1.983 1.9v10.285c0 1.05.888 1.9 1.983 1.9zm1.983 4.024c0-1.11-.888-2.012-1.983-2.012-1.095 0-1.983.901-1.983 2.012s.888 2.013 1.983 2.013c1.095 0 1.983-.902 1.983-2.013z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconWarningFilled;
